/**
 * @generated SignedSource<<182e721961a543ba0b9ca69c4ec2aa01>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type actions_projectVersions_ActionsCell_jiraVersion$data = {
  readonly __id: string;
  readonly allIssues: {
    readonly totalCount: number;
  };
  readonly doneIssues: {
    readonly totalCount: number;
  };
  readonly id: string;
  readonly name: string;
  readonly status: JiraVersionStatus;
  readonly versionId: string;
  readonly " $fragmentSpreads": FragmentRefs<"mergeReleaseModal_softwareReleasesReleaseModalsRelay_jiraVersion">;
  readonly " $fragmentType": "actions_projectVersions_ActionsCell_jiraVersion";
};
export type actions_projectVersions_ActionsCell_jiraVersion$key = {
  readonly " $data"?: actions_projectVersions_ActionsCell_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"actions_projectVersions_ActionsCell_jiraVersion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "totalCount"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "actions_projectVersions_ActionsCell_jiraVersion",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "versionId"
      },
      "action": "THROW",
      "path": "versionId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "status"
      },
      "action": "THROW",
      "path": "status"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "allIssues",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "allIssues.totalCount"
          }
        ],
        "storageKey": "issues(filter:\"ALL\")"
      },
      "action": "THROW",
      "path": "allIssues"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "doneIssues",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "doneIssues.totalCount"
          }
        ],
        "storageKey": "issues(filter:\"DONE\")"
      },
      "action": "THROW",
      "path": "doneIssues"
    },
    {
      "kind": "FragmentSpread",
      "name": "mergeReleaseModal_softwareReleasesReleaseModalsRelay_jiraVersion"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "__id"
          },
          "action": "THROW",
          "path": "__id"
        }
      ]
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "de48072074c29111b9724b11cad9c676";

export default node;
